{
  "common": {
    "show": "Mostrar",
    "about": "Acerca de",
    "newPost": "Nova publicação",
    "active": "Ativo",
    "change": "Alterar",
    "remove": "Remover",
    "cancel": "Cancelar",
    "publish": "Publicar",
    "save": "Guardar",
    "draft": "Rascunho",
    "scheduled": "Agendado",
    "published": "Publicado",
    "actions": "Ações",
    "archive": "Arquivar",
    "delete": "Eliminar",
    "edit": "Editar",
    "edited": "Editado",
    "settings": "Definições",
    "signUp": "Inscrever-se",
    "by": "Via",
    "for": "para",
    "you": "O utilizador",
    "one": "um",
    "option": "Opção ",
    "registered": "Registado",
    "to": "para",
    "allEvents": "Todos os eventos",
    "placeholder": "marcador de posição",
    "percentOf": "% de",
    "private": "Privado",
    "updatedOn": "Atualizado em",
    "blogPost": "Publicação no blogue",
    "category": "Categoria",
    "author": "Autor",
    "status": "Estado",
    "errors": "Erros",
    "all": "Todos",
    "archived": " Arquivado",
    "back": "Voltar",
    "restore": "Restaurar esta versão",
    "next": "Seguinte",
    "previous": "Anterior",
    "continue": "Continuar",
    "continueButton": "Continuar",
    "paid": "Pago",
    "free": "Grátis",
    "uploadImagesVideos": "Carregar imagens/vídeos",
    "upload": "Carregar",
    "add": "Adicionar",
    "on": "Ativado",
    "from": "de",
    "members": "membros",
    "visibility": "Visibilidade",
    "public": "Público",
    "description": "Descrição",
    "managedBy": "Gerido por",
    "noManagers": "Sem Gestores",
    "noDescription": "Sem descrição",
    "more": "mais",
    "moreCaps": "Mais",
    "less": "menos",
    "and": "e ainda",
    "in": "em",
    "allSet": "Tudo pronto!",
    "createdBy": "Criado por",
    "home": "Início",
    "selected": "Selecionado",
    "groupMembers": "Membros do Grupo",
    "everyone": "Todos",
    "manager": "Gestor",
    "leave": "Sair",
    "membersList": "Lista de Membros",
    "findChannelManagers": "Descobrir Channel Managers",
    "searchGroupMembers": "Pesquisar Membros do Grupo",
    "searchMembers": "Pesquisar Membros",
    "searchMember": "Pesquisar Membro",
    "enterDescription": "Insira a descrição",
    "apply": "Aplicar",
    "selectRole": "Selecionar Função",
    "people": "Pessoas",
    "viewProfile": "Ver Perfil",
    "leaderboard": "Tabela de classificação",
    "events": "Eventos",
    "logOut": "Sair",
    "topLevelReached": "Nível máximo atingido",
    "topLevelReachedExclaim": "Nível máximo atingido!",
    "congratsTopLevel": "Parabéns! Atingiu o nível máximo!",
    "share": "Partilhar",
    "copyLink": "Copiar ligação",
    "reply": "Responder",
    "download": "Descarregar",
    "noPreviewAvailable": "Nenhuma pré-visualização disponível",
    "userNotFound": "Utilizador não encontrado",
    "userNotFoundMessage": "Utilizador não encontrado",
    "thisGroupIsPrivate": "Este grupo é privado",
    "unableToPreviewPdf": "Atualmente, não é possível pré-visualizar o ficheiro PDF. Faça o download para visualizar.",
    "failedToDownloadPdf": "Falha ao descarregar o ficheiro PDF",
    "notifyAll": "Notificar todos no canal",
    "communities": "Comunidades",
    "courses": "Cursos",
    "affiliates": "Afiliados",
    "chats": "Conversar",
    "switchToDarkMode": "Mudar para o modo escuro",
    "switchToLightMode": "Mudar para o modo Claro",
    "editProfile": "Editar Perfil",
    "account": "Conta",
    "logout": "Sair",
    "noResults": "Nenhum resultado",
    "confirmPayment": "Confirme Pagamento",
    "done": "Concluído",
    "manage": "GERIR",
    "copied": "Copiado",
    "submit": "Enviar",
    "request": "Pedido",
    "approve": "Aprovar",
    "decline": "Recusar",
    "comingSoon": "Brevemente",
    "detailsUpdatedSuccessfully": "Os detalhes foram atualizados com sucesso",
    "oopsUnableToSaveDetails": "Ups! Não foi possível salvar os detalhes.",
    "verificationFailedPleaseTryAgain": "Falha na verificação! Tente novamente",
    "loading": "A carrregar",
    "title": "Título",
    "addLink": "Adicionar Ligação",
    "writeHere": "Escreva aqui",
    "copy": "Copiar",
    "reset": "Repor",
    "register": "Registar",
    "search": "Pesquisar",
    "confirm": "Confirmar",
    "success": "Sucesso",
    "toReview": "Para Revisão",
    "invite": "Convite",
    "contributions": "Contribuições",
    "communitiesSettings": "Definições de Comunidades",
    "create": "Criar",
    "name": "Nome",
    "linkCopied": "Ligar, vincular Copiado!",
    "move": "Mover",
    "irreversible": "irreversível",
    "close": "Fechar",
    "greeting": "Bom dia, {name}!",
    "managePayments": "Gerir Pagamentos",
    "manageYourAccount": "Gerir a sua Conta",
    "accountSettings": "Definições da Conta",
    "proceed": "Prosseguir",
    "uploading": "A carregar",
    "retry": "Repetir",
    "login": "Iniciar sessão",
    "follow": "Seguir",
    "following": "A seguir",
    "followers": "Seguidores",
    "view": "VER",
    "selectAnOption": "Selecionar uma opção",
    "channels": "Canais",
    "somethingWentWrong": "Algo correu mal, tente novamente",
    "switchToNormalMode": "Mudar para o modo normal",
    "switchToReadingMode": "Altere para o modo de leitura",
    "goToHomepage": "Ir para a Página Inicial",
    "onlyGroupOwnersCanCreateCourses": "Apenas os proprietários do grupo podem criar novos cursos",
    "createGroup": "Criar grupo",
    "discover": "Discover",
    "continuePayment": "Continuar Pagamento",
    "invalidCredentials": "Introduziu um e-mail ou uma palavra-passe inválida. Tente novamente.",
    "comingUpEvents": "Próximas eventos!",
    "integratePaymentGateway": "Integrar gateway de pagamento",
    "connectPaymentGateway": "Ligue um novo gateway de pagamento ou faça a gestão dos seus gateways existentes.",
    "isLive": "está ativo",
    "justNow": "Agora mesmo",
    "likes": "Gostos",
    "accessRequired": "Acesso*",
    "zeroProgress": "0",
    "noFollowersTitle": "Parece que ninguém o Seguir.",
    "noFollowersSubtext": "Adicionar a sua ligação à lista de seguir",
    "noFollowingTitle": "O utilizador ainda não segue ninguém.",
    "noFollowingSubtext": "Início a Seguinte pessoas para ver as suas publicações",
    "followBack": "Seguir de volta",
    "logIn": "GERIR",
    "video": "Vídeo",
    "audio": "Áudio",
    "newVersionAvailable": "Está disponível uma nova versão da aplicação. Por favor, atualize para utilizar esta funcionalidade!",
    "ariaLabels": {
      "backButton": "Botão Voltar",
      "openEventLocation": "Abrir localização do evento",
      "editEvent": "Editar evento",
      "deleteEvent": "Eliminar evento",
      "cancelRsvp": "Anulado RSVP",
      "publicGroupRadio": "Botão de rádio do grupo público",
      "privateGroupRadio": "Botão de rádio de grupo privado",
      "accessibleFromSwitcherCheckbox": "Acessível a partir da caixa de verificação do comutador",
      "allowMembersToInviteCheckbox": "Caixa de verificação Permitir que os membros convidem",
      "addMembers": "Adicionar membros",
      "settings": "Definições",
      "leaveChannel": "Sair do canal",
      "channelSettings": "Configurações do Canal",
      "selectRole": "Selecionar função",
      "deleteChannel": "Eliminar canal",
      "changeToPrivateChannel": "Alterar para Canal Privado",
      "allowMembersToPosts": "Permitir que os membros façam publicações",
      "restrictMembersFromPosts": "Impedir que os membros enviem publicações",
      "close": "Fechar",
      "open": "Abrir",
      "more": "Mais",
      "upload": "Carregar",
      "play": "Reproduzir",
      "pause": "Pausar",
      "mute": "Desativar o som",
      "unmute": "Ativar o som",
      "fullscreen": "Ecrã completo",
      "exitFullscreen": "Sair do ecrã completo",
      "download": "Descarregar",
      "share": "Partilhar",
      "like": "Gostar",
      "comment": "Comentar",
      "reply": "Responder",
      "pin": "Afixar",
      "unpin": "Desafixar",
      "report": "Relatório",
      "copyLink": "Copiar ligação",
      "embedCode": "Código de incorporação",
      "previewImage": "Pré-visualizar imagem",
      "profileImage": "Imagem de perfil",
      "coverImage": "Imagem da capa",
      "thumbnail": "Miniatura",
      "attachment": "Anexo",
      "removeAttachment": "Remover anexo",
      "uploadFile": "Carregar ficheiro",
      "selectFile": "Selecionar ficheiro",
      "searchIcon": "Ícone da pesquisa",
      "menuIcon": "Ícone de menu",
      "notification": "Notificação",
      "messages": "Mensagens",
      "profile": "Perfil",
      "logout": "Terminar sessão",
      "send": "Enviar",
      "cancel": "Cancelar",
      "submit": "Enviar",
      "next": "Seguinte",
      "previous": "Anterior",
      "refresh": "Atualizar",
      "filter": "Filtrar",
      "sort": "Ordenar",
      "view": "Ver",
      "expand": "Expandir",
      "collapse": "Reduzir",
      "downloadFile": "Descarregar ficheiro",
      "closeModal": "Fechar modal",
      "addMedia": "Adicionar multimédia",
      "lightModeRadio": "Botão de rádio de modo claro",
      "darkModeRadio": "Botão de rádio de modo escuro",
      "communityThemeRadio": "Botão de rádio de tema da comunidade",
      "userProfile": "Perfil de utilizador",
      "postActions": "Ações de Publicação",
      "chatWindow": "Janela de chat",
      "chatActions": "Ações de chat",
      "minimizeChat": "Minimizar chat",
      "closeChat": "Fechar chat",
      "commentActions": "Ações de comentário",
      "replyToComment": "Responder a um comentário",
      "groupLogo": "Logótipo do grupo",
      "pinGroupIcon": "Fixar ícone de comunidade",
      "appSwitcher": "Comutador de aplicações",
      "communities": "Comunidades",
      "courses": "Cursos",
      "search": "Pesquisar",
      "giphyLogo": "Logótipo Giphy",
      "backToConversations": "Voltar para Conversas",
      "commentAttachments": "Anexos de comentários",
      "tabSwitcher": "Comutador de separadores",
      "eventCover": "Cobertura de evento",
      "eventCoverPreview": "Pré-visualizar cobertura de evento",
      "selectPaidEvent": "Selecionar evento pago",
      "selectFreeEvent": "Selecionar evento gratuito",
      "selectCurrency": "Selecionar moeda",
      "logo": "Logótipo",
      "closeReviewMembershipAnswersModal": "Fechar modal de respostas da associação de revisão",
      "liveStream": "Transmissão em direto",
      "openGroupMembers": "Abrir membros da comunidade",
      "communityBanner": "Banner da comunidade",
      "home": "Início",
      "mentionItem": "Item da menção",
      "back": "Voltar",
      "viewGroup": "Ver grupo",
      "invitationIcon": "Ícone de Convite",
      "openUserProfile": "Abrir Perfil de Utilizador",
      "closeStream": "Fechar transmissão",
      "groupAvatar": "Avatar do grupo",
      "bannerImage": "Imagem de banner",
      "avatarImage": "Imagem de Avatar",
      "userAvatar": "Avatar do Utilizador",
      "eventImage": "Imagem do evento",
      "postImage": "Imagem da publicação",
      "channelIcon": "Ícone do Canal",
      "groupIcon": "Ícone de grupo",
      "communityIcon": "Ícone da comunidade",
      "memberAvatar": "Avatar de membro",
      "creatorAvatar": "Avatar de criador",
      "authorAvatar": "Avatar do autor",
      "aboutFeaturedPost": "Sobre a publicação em destaque",
      "accountSettings": "Definições da conta",
      "addChannel": "Adicionar canal",
      "addCourse": "Adicionar curso",
      "addEmoji": "Adicionar emoji",
      "affiliates": "Afiliados",
      "announceEvents": "Anunciar eventos",
      "avatar": "Avatar",
      "badge": "Distintivo",
      "camera": "Câmara",
      "cardImage": "Imagem de cartão",
      "categoryName": "Nome da categoria",
      "channelList": "Lista de Canais",
      "channelSelect": "Seleção de canais",
      "chatAttachment": "Anexo de chat",
      "chats": "Chats",
      "closeCourseDetails": "Fechar detalhes do curso",
      "closeLoginModal": "Fechar modal de início de sessão",
      "closeMembershipQuestionsModal": "Fechar modal perguntas de associação",
      "closePaymentModal": "Fechar modal de pagamento",
      "commentCard": "Cartão de comentário",
      "communityTheme": "Tema da comunidade",
      "conversationItem": "Item de conversa",
      "conversationSuggestion": "Sugestão de conversa",
      "createChannel": "Criar Canal",
      "customThemeRadio": "Botão de rádio de tema personalizado",
      "deleteAnswerButton": "Botão Eliminar resposta",
      "deleteFile": "Eliminar ficheiro",
      "editLevelName": "Editar nome do nível",
      "editProfile": "Editar perfil",
      "enterEmailAddress": "Introduzir endereço de e-mail",
      "featuredIcon": "Ícone em destaque",
      "giveAdministrativePrivileges": "Conceder privilégios administrativos",
      "gokollabLogo": "Logótipo Gokollab",
      "icon": "Ícone",
      "image": "Imagem",
      "likeContent": "Gostar de conteúdo",
      "link": "Ligação",
      "marketplaceGroupSlug": "Slug do grupo do mercado",
      "microphone": "Microfone",
      "nextAttachment": "Anexo seguinte",
      "noEvents": "Sem eventos",
      "noCommunitiesIllustration": "Sem ilustração de comunidades",
      "noCoursesFound": "Nenhum curso encontrado",
      "noFollowers": "Sem seguidores",
      "noFollowing": "Sem seguinte",
      "noPostsFound": "Nenhuma publicação encontrada",
      "notificationItem": "Item de notificação",
      "notificationsList": "Lista de notificações",
      "openEmbeds": "Incorporações abertas",
      "openEmbedsDrawer": "Gaveta de incorporações abertas",
      "openEventColor": "Cor do evento aberto",
      "openEventDetails": "Detalhes do evento aberto",
      "permissionNeeded": "Permissão necessária",
      "pointsAndLevels": "Pontos e níveis",
      "previousAttachment": "Anexo anterior",
      "reactedUser": "Utilizador que Reagiu",
      "reward": "Recompensa",
      "rewards": "Recompensas",
      "selectChannel": "Selecionar canal",
      "selectEventOption": "Selecionar opção de evento",
      "selectIcon": "Selecionar ícone",
      "selectTimezone": "Selecionar fuso horário",
      "showChannelIcons": "Mostrar ícones do canal",
      "sidebarActionButton": "Botão de ação da barra lateral",
      "speaker": "Altifalante",
      "text": "Texto",
      "thisGroupIsPrivate": "Este grupo é privado",
      "toReview": "Para revisão",
      "toggleFeaturedPost": "Alternar Publicação em Destaque",
      "toggleRewardsOptions": "Alternar Opções de Recompensas",
      "viewReplies": "Ver Respostas",
      "courseThumbnail": "miniatura-curso",
      "moreManagers": "mais gestores",
      "arrowIcon": "→",
      "okHandEmoji": "👌",
      "closeIcon": "✕",
      "changeToPublicChannel": "Alterar para Canal público",
      "showMandatoryInfoModal": "Exibir caixa de seleção modal de perfil obrigatório"
    },
    "placeholders": {
      "groupName": "Nome do grupo",
      "groupSlug": "Slug do grupo",
      "url": "URL",
      "enterPrice": "Introduzir preço",
      "enterName": "Introduzir nome",
      "enterEmail": "Introduzir e-mail",
      "selectTimezone": "Selecionar fuso horário",
      "selectChannel": "Selecionar canal",
      "enterSkoolGroupUrl": "Insira a URL do grupo da sua Skool"
    },
    "email": "E-mail",
    "errorLoadingConversations": "Erro ao carregar conversas",
    "noConversations": "Nenhuma conversa"
  },
  "imageUpload": {
    "cropYourAvatar": "Cortar o seu avatar",
    "dragToReposition": "Arraste para reposicionar",
    "ariaLabels": {
      "imageUploader": "Carregador de imagens",
      "avatar": "Avatar",
      "clearFile": "Limpar Ficheiro",
      "removeAvatar": "Remover avatar do perfil",
      "zoomButton": "Botão de Zoom"
    }
  },
  "mediaUpload": {
    "uploadVideo": "Carregar vídeo",
    "addVideoUsingLink": "Adicionar vídeo usando link",
    "uploadImage": "Carregar imagem",
    "addVideo": "Adicionar vídeo"
  },
  "mandatedInfoModal": {
    "completeYourProfile": "Complete o seu Perfil",
    "profileIntentMessage1": "As comunidades sentem-se estranhas sem rostos e nomes.",
    "profileIntentMessage2": "Perfis constroem Crédito e desencadeiam conexão com outras pessoas",
    "complete": "COMPLETO",
    "recommendedAspectRatio": "Carregar um {types}. Percentagem de Aparência Recomendado 1:1",
    "addBio": "Adicione uma biografia... (Opcional)"
  },
  "validations": {
    "nameRequired": "O nome é obrigatório!",
    "invalidDescription": "Descrição inválida!"
  },
  "payment": {
    "recurringWithTrial": "Serás cobrado {currencySymbol}{price} por {interval} depois do período de avaliação com a opção de cancelar a qualquer momento.",
    "recurring": "{currencySymbol}{price} por {interval} com a opção de cancelar a qualquer momento.",
    "oneTime": "{currencySymbol}{price} {paymentText}",
    "defaultOneTimeText": "Preço único para Assinatura.",
    "totalAmount": "Montante Total",
    "trialDays": "Teste de {days} dias",
    "securePayments": "Pagamentos 100% seguros e protegidos",
    "allowToChargeCard": "Ao fornecer as informações do seu cartão, você permite que {locationName} cobre o cartão para pagamentos futuros de acordo com seus termos.",
    "paymentSuccessful": "Pagamento bem-sucedido!"
  },
  "channel": {
    "notifications": {
      "managersEdited": "Gestores editados com sucesso!",
      "managersAdded": "Gestores adicionados com sucesso!",
      "managersAddedToChannel": "gestores adicionados a",
      "membersAdded": "Membros adicionados com sucesso!",
      "memberPostingEnabled": {
        "title": "Publicação de Membros atualizada com sucesso",
        "content": "A publicação de Membros foi Ativado"
      },
      "roleUpdated": "Função atualizada com sucesso!",
      "updatedRoleOf": "Função atualizada de {name}",
      "userRemoved": "Utilizador removido com sucesso!",
      "removedUserFrom": "{name} removido de {channelName}",
      "errorOccurred": "Ocorreu um erro",
      "updated": {
        "title": "Configurações de canal atualizadas",
        "contentPrivate": "O canal {channelName} agora é privado",
        "contentPublic": "O canal {channelName} agora é público",
        "content": ""
      },
      "deleted": {
        "title": "O canal foi eliminado com sucesso",
        "content": ""
      },
      "membersAddedSuccess": {
        "title": "Membros adicionados com sucesso!",
        "content": "{count} membros adicionados a {channelName}"
      },
      "managersAddedSuccess": {
        "title": "Gestores adicionados com sucesso!",
        "content": "{count} gestores adicionados a {channelName}"
      },
      "memberPostingDisabled": {
        "title": "Publicação de Membros atualizada com sucesso",
        "content": "A publicação de Membros foi Desativado"
      },
      "visibilityChangedToPublic": "O canal {channelName} agora é público",
      "visibilityChangedToPrivate": "O canal {channelName} agora é privado",
      "created": {
        "title": "Novo canal criado",
        "content": ""
      },
      "error": {
        "createFailed": {
          "title": "Falha na criação do canal",
          "content": "Tente novamente mais tarde"
        },
        "updateFailed": {
          "title": "Falha ao atualizar o canal",
          "content": "Tente novamente mais tarde"
        },
        "managersEditedFailed": {
          "title": "Atualização de gerentes sem sucesso!",
          "content": ""
        },
        "addFailed": {
          "title": "Adicionar gerentes não foi bem-sucedido!",
          "content": ""
        },
        "addMembersFailed": {
          "title": "A adição de membros não foi bem-sucedida!",
          "content": ""
        }
      }
    },
    "createChannel": "Criar canal",
    "updateChannel": "Atualizar canal",
    "addMembers": "Adicionar Membros",
    "addManagers": "Adicionar Gestores",
    "typeToAddMoreMembers": "Escreva para adicionar mais membros",
    "examplePlaceholder": "ex. John ou Jane",
    "makeChannelManager": "Criar Channel Manager",
    "removeFromChannelManager": "Extrair do Channel Manager",
    "manager": "Gestor",
    "channelManager": "Gestor de Canais",
    "noMembersFound": "Nenhum membro encontrado.",
    "noManagersFound": "Nenhum gestor encontrado.",
    "removeChannelMember": "Extrair Membro do Canal",
    "removeConfirmationMessage": "Tem certeza de que deseja remover",
    "makeManagerConfirmationMessage": "Tem certeza de que deseja tornar",
    "makeManagerConfirmationMessage2": "um gestor de canal in",
    "channelName": "Nome do Canal",
    "channelIcon": "Ícone do Canal",
    "addChannel": "Adicionar Canal",
    "editChannel": "Editar canal",
    "announcementChannel": "Canal AVISO",
    "noChannelsAvailable": "Nenhum canal disponível",
    "makeChannelPrivate": "Tornar Canal Privado",
    "makeChannelPrivateMessage": "Restringir o acesso do membro a todas as discussões do canal & interações.",
    "readOnlyChannel": "Canal só de Ler",
    "readOnlyChannelMessage": "Os Membros podem Ver informações e atualizações IMPORTANTES, mas apenas os administradores/ proprietários do canal podem História aqui.",
    "createPrivateChannel": "Tornar este canal privado",
    "createPrivateChannelMessage": "Apenas Membros Convidados. Não Membros não verão este Espaço",
    "allowMembersToPost": "Ativar Membros da História",
    "allowMembersToPostMessage": "Ativar esta opção Ativar Membros para Criar publicações e comentários",
    "enableMemberPostingConfirmation": {
      "mainMessage": "Ativar a publicação dos Membros irá Ativar todos os Membros para Criar e Partilhar publicações dentro do canal.",
      "mainMessage2": "Certifique-se de que todos os Membros têm conhecimento das novas permissões de publicação.",
      "pointer1": "Esta ação pode ser revertida em quaisquer dados.",
      "pointer2": "todas as publicações criadas por Membros ficarão visíveis para Todos in canal."
    },
    "privateChannelTooltip": "Não tem acesso a este canal",
    "restrictMembersFromPosting": "Restringir Membros De publicação",
    "restrictMembersFromPostingMessage": "Desativar esta opção impedirá que os Membros De Criado Ou editem publicações e comentários dentro do canal.",
    "disableMemberPostingConfirmation": {
      "mainMessage": "Desativar a publicação de Membros excluirá todos os Membros De Criado e a partilha de publicações dentro do canal.",
      "mainMessage2": "Certifique-se de que todos os Membros têm conhecimento das novas restrições de publicação.",
      "pointer1": "Esta ação pode ser revertida em quaisquer dados.",
      "pointer2": "todas as publicações Criado por Membros Antes desta Alterar ficarão visíveis para Todos in canal."
    },
    "deleteChannel": "Eliminar Canal",
    "deleteChannelMessage": "Excluir o canal perderá permanentemente todos os dados associados.",
    "deleteChannelMessageWithCourse": "Excluir o canal perderá permanentemente todos os dados dos Membros e quaisquer Cursos ligados a este canal tornar-se-ão o Público, a menos que o utilizador os elimine primeiro.",
    "editChannelName": "Editar nome do canal",
    "editChannelDescription": "Editar descrição do canal",
    "channelNamePlaceholder": "p.ex. Relatórios de marketing",
    "editManagers": "Editar gestores",
    "channelManagers": "Gerentes de Canal",
    "leaveChannel": "Sair do Canal",
    "leaveChannelConfirmation": "O utilizador tem a certeza de que o utilizador pretende Sair deste canal?",
    "changeToPrivateChannel": "Tornar Canal Privado",
    "changeToPrivateChannelMessage": "Ao tornar o canal privado, irá restringir a utilização do canal para interações e discussões apenas aos seus membros.",
    "changeToPrivateChannelConfirmation": {
      "mainMessage": "Mudar este canal para Privado irá SLOTMAX Acesso para Selecionado Membros e gestores apenas.",
      "mainMessage2": "Lembre-se de Incluir todos os Membros desejados no seu canal Privado.",
      "pointer1": "Esta ação é",
      "pointer2": "novos Membros adicionados ao canal terão Acesso a todos PASSADO discussões e interações dentro do canal."
    },
    "changeToPublicChannel": "Tornar Canal Público",
    "changeToPublicChannelMessage": "Tornar o Canal Público permitirá que Todos os Membros do Grupo Ativar e Ver e registar-se neste Canal.",
    "changeToPublicChannelConfirmation": {
      "mainMessage": "Tornar este Canal Público tornará acessível a Todos os Membros da comunidade.",
      "mainMessage2": "Todos os membros do grupo poderão ver e registar-se neste canal.",
      "pointer1": "Todos os Membros da comunidade terão Iniciar sessão a este Canal automaticamente.",
      "pointer2": "O Multimédia do Canal Privado PASSADO ficará visível para Todos os Membros do Grupo."
    },
    "publicChannel": "Canal Público",
    "peopleWhoCanManage": "Pessoas que podem gerir",
    "addChannelHelperText": "Mostrar mais comunidade: Adicionar canais para diversas discussões, Duet e Ligação.",
    "privateChannel": "Canal Privado",
    "removeFromChannel": "Remover do canal",
    "removeConfirmationMessage2": "deste canal",
    "findChannelManagers": "Encontrar gestores de canais",
    "removeChannelManager": "Remover gestor de canais",
    "irreversible": "Esta ação é irreversível"
  },
  "chat": {
    "unblockUser": "Desbloquear Utilizador",
    "blockUser": "Bloquear utilizador",
    "blockMessage1": "O utilizador não poderá mais enviar mensagens para este utilizador.",
    "blockMessage2": "Esta conta não será bloqueada na coleção. Ainda poderá ver as suas postagens, comentários e reações.",
    "deleteChat": "Eliminar Chat",
    "deleteChatMessage": "Tem a certeza de que pretende eliminar esta conversa?",
    "block": "Bloco",
    "conversation": "Conversa",
    "youPrefix": "Utilizador: ",
    "messageNotSent": "Esta mensagem não foi enviada",
    "sending": "Envio",
    "youAndUserKnowEachOther": "Você e {name} se conhecem",
    "startConversationWithHi": "Inicie uma conversa enviando \"Olá\"",
    "accountSettings": "Definições da conta",
    "blockedUserMessage": "Bloqueou { name }. Não pode enviar ou receber mensagens. Desbloqueie-os para iniciar uma conversa. Para rever a sua Lista de Utilizadores bloqueados, visite o seu",
    "blockRecipientMessage": "{ name } bloqueou o utilizador. O utilizador não pode carregar ou receber mensagens.",
    "nothingFound": "Nada encontrado!",
    "pleaseCheckUsername": "Por favor, verifique o Nome de utilizador e tente novamente",
    "startChatting": "Começar a Conversar",
    "noChatYet": "Parece que ainda não conversou com ninguém.",
    "noChatYetMessage": "Pesquise um contacto e dê o primeiro passo!",
    "noConversationsFound": "Nenhuma conversa encontrada",
    "searchMembersAndStartChatting": "Pesquise membros e comece a conversar",
    "cannotMessageDeletedUser": "o utilizador não pode carregar mensagens para um utilizador eliminado",
    "message": "Mensagem",
    "media": "Multimédia",
    "files": "Ficheiros"
  },
  "comments": {
    "reportComment": "Denunciar comentário",
    "reportCommentMessage": "Tem a certeza de que pretende denunciar este comentário?",
    "deleteComment": "Apagar comentário",
    "editComment": "Editar comentário",
    "loadMoreReplies": "Carregar mais respostas",
    "deleteCommentMessage": "Tem a certeza de que pretende eliminar este comentário?",
    "writeComment": "Escreva um comentário",
    "comment": "COMENTAR",
    "cancel": "CANCELAR",
    "save": "GUARDAR",
    "replyingTo": "Responder a",
    "newComment": "novo comentário",
    "latest": "Mais recente",
    "onlyAdminsCanComment": "Apenas os administradores da comunidade podem fazer comentários in canal.",
    "isCommentDisabledForPost": "Os comentários estão desativados para esta publicação.",
    "isCommentDisabledErrorContent": "Os comentários foram desativados neste post pelo autor ou pelo administrador do grupo.",
    "isCommentDisabledErrorTitle": "Comentários Desativados"
  },
  "embeds": {
    "uploadImage": "Carregar imagem",
    "addYoutubeVimeoLoomLink": "Adicionar um link Youtube, Vimeo ou Loom",
    "uploadAttachment": "Carregar ficheiros PDF, CSV ou XLSX",
    "addAttachment": "Adicionar anexo",
    "allowedTypes": "SVG, PNG, JPG ou GIF (máx. 800x400px)",
    "placeholder": "Adicionar um link Youtube, Vimeo ou Loom",
    "uploadVideo": "Carregar/Vincular vídeo",
    "uploadVideoPlaceholder": "Adicionar um link Youtube, Vimeo ou Loom",
    "uploadVideoAllowedTypes": "Carregue um ficheiro de vídeo MP4",
    "addEmoji": "Adicione um emoji",
    "emojiSuggestion": "Abre o selecionador de Emoji",
    "addGif": "Adicionar GIF",
    "gifSuggestion": "Abre o selecionador de GIF",
    "addImage": "Adicionar imagem",
    "imageSuggestion": "Abre a sua galeria",
    "addVideo": "Adicionar vídeo",
    "videoSuggestion": "Abre a sua galeria",
    "selectFile": "Selecionar Documento",
    "attachmentSuggestion": "Abre o gestor de Documento",
    "takePhoto": "Tire foto",
    "uploadPhotoVideo": "Carregar foto/vídeo",
    "limitExceeded": "Limite excedido",
    "limitExceededMessage": "O utilizador não pode anexar mais de 4 ficheiros",
    "errorWhileUploadingFile": "Erro ao carregar ficheiro! Tente novamente",
    "clickToUpload": "Clique para carregar",
    "orDragAndDrop": "ou arrastar e largar",
    "validUrl": "É necessário um URL válido",
    "enterSomeText": "Insira algum texto",
    "addLink": "Adicionar ligação",
    "text": "Texto",
    "addVideoLink": "Ou, Incluir a YouTube, Vimeo, Loom, Ou Wistia Vídeo Ligar, vincular.",
    "uploadVideoAndImages": "Carregar vídeos e imagens",
    "recommendedAspectRatio": "Percentagem de Aparência Recomendado {ratio}",
    "addHashtag": "Etiqueta canais, ocorrências e Cursos",
    "hashtagSuggestion": "Sugestão de Hashtag"
  },
  "tabSwitcher": {
    "discussion": "Discussão",
    "learning": "aprendizagem",
    "members": "Membros",
    "people": "Pessoas",
    "leaderboard": "Tabela de classificação",
    "channels": "Canal",
    "groups": "Grupos",
    "more": "Mais",
    "home": "Início",
    "discover": "Descobrir",
    "courses": "Cursos",
    "communities": "Comunidades"
  },
  "groupInfo": {
    "pinGroup": "Grupo de Pins",
    "unpinGroup": "Desaperte o Grupo",
    "maxPinnedGroupsLimit": "Apenas um máximo de 4 grupos podem ser fixados",
    "publicGroup": "Grupo público",
    "privateGroup": "Grupo Privado",
    "coverImage": "Cobertura do grupo",
    "members": "Membros",
    "posts": "Posts",
    "admin": "Administrador",
    "settings": "CONFIGURAÇÕES",
    "inviteMembers": "CONVIDAR MEMBROS",
    "answerQuestions": "Responder a perguntas",
    "toJoin": "para juntar {name}",
    "leaveGroup": "Sair do Grupo",
    "leaveGroupConfirmMessage": "Tem a certeza de que pretende sair deste grupo? Perderá o acesso a todos os cursos pagos, eventos pagos e à sua adesão ao grupo.",
    "leaveGroupSuccessTitle": "Saiu do grupo",
    "leaveGroupSuccessMessage": "Saiu do grupo com sucesso.",
    "leaveGroupErrorTitle": "Não é possível sair do grupo",
    "leaveGroupErrorMessage": "Algo correu mal ao sair do grupo. Tente novamente.",
    "groupActions": "Ações de grupo",
    "changeRole": "Alterar Função",
    "removeFromGroup": "Remover do grupo",
    "contributor": "Colaborador",
    "membershipAnswers": "Respostas de Associação",
    "unbanMember": "Membro Unban",
    "banFromGroup": "Banir do grupo",
    "requestedOn": "Solicitado em",
    "invitedOn": "Convidado em",
    "joinedOn": "Aderiu",
    "noMembersFound": "Nenhum membro encontrado.",
    "youAreAllCaughtUp": "utilizador're todos apanhados — no Membros aqui Direita agora!",
    "banUserConfirmation": "Tem a certeza de que pretende banir este utilizador do grupo?",
    "deleteContentCheckbox": "Eliminar todo o conteúdo criado por este utilizador",
    "active": "Ativo",
    "admins": "Administradores",
    "contributors": "Contribuintes",
    "requested": "Solicitado",
    "banned": "Banido",
    "invited": "Convidado",
    "paymentReceived": "Pagamento recebido",
    "paymentInitiated": "Pagamento Iniciado",
    "answeredQuestions": "Perguntas respondidas",
    "answeredQuestionsMessage": "respondeu à seguinte pergunta para aderir",
    "darkMode": "Modo escuro",
    "darkModeMessage": "Modificar a aparência da comunidade para reduzir o brilho e dar um tempo aos seus olhos.",
    "accessGranted": "Acesso concedido: comece a sua aventura de aprendizagem.",
    "stepIntoAction": "Entre em ação! Vamos colaborar e divertir-nos.",
    "viewMembersAndMemberDetails": "Ver membros e detalhes dos membros",
    "reviewContentReportsAndMore": "Revisão de relatórios de conteúdo e muito mais",
    "toReview": "Para Revisão",
    "switchToOtherGroups": "Mudar para Outros Grupo",
    "placeholders": {
      "yourAnswer": "A sua resposta"
    },
    "notifications": {
      "userBanned": "Utilizador banido do grupo com sucesso",
      "somethingWentWrong": "Algo correu mal. Tente novamente mais tarde."
    },
    "membershipSettings": "Configurações de Assinatura",
    "paymentFailed": "O pagamento falhou!",
    "paymentFailedMessage": "O pagamento falhou, o seu pedido para se registar no grupo foi recusado.",
    "gamification": {
      "addRewards": "Adicionar Recompensas",
      "title": "Título",
      "description": "Adicionar descrição",
      "textbox": "Caixa de texto",
      "singleSelect": "Seleção única",
      "multipleSelect": "Seleção múltipla",
      "question": "Pergunta",
      "validations": {
        "titleRequired": "Forneça o título",
        "descriptionRequired": "Forneça uma descrição",
        "somethingWentWrong": "Algo correu mal. Tente novamente mais tarde.",
        "updatedRewards": "Recompensas atualizadas"
      },
      "settings": {
        "updatedRewards": "Recompensas atualizadas"
      }
    },
    "customCode": {
      "advanced": "Avançado",
      "testPreview": "Pré-visualização do teste",
      "enableConfirmationMessage": "Ativar somente após verificar a pré-visualização do teste",
      "testPreviewMessage": "Isso irá abrir uma nova aba com a pré-visualização do teste da sua comunidade. Pode usar isto para verificar se o seu Código personalizado está a funcionar conforme o esperado.",
      "liveMode": "Modo Em direto",
      "customJS": "JS Personalizado",
      "customCSS": "CSS Personalizado",
      "trackingCode": "Código de rastreio",
      "headerCode": "Código do cabeçalho",
      "footerCode": "Código do Rodapé"
    },
    "branding": {
      "brandYourGroup": "O utilizador pode marcar a sua Coleção de acordo com a sua escolha aqui",
      "updateBranding": "Atualizar marca",
      "clickToUploadFavicon": "Click para carregar o Favicon",
      "dragAndDropFavicon": "Arrastar e soltar um {types} (Proporção de Aparência 1:1)",
      "clickToUploadCover": "Clicar para carregar a capa",
      "dragAndDropCover": "Arrastar e soltar um {types} (Proporção de Aparência 16:9)",
      "clickToUploadLogo": "Clicar para carregar o Logótipo do Grupo",
      "dragAndDropLogo": "Arrastar e soltar um {types} (Proporção de Aparência 1:1)",
      "aspectRatioMustBe1To1": "A proporção da imagem tem de ser 1:1",
      "aspectRatioMustBe16To9": "A proporção da imagem tem de ser 16:9",
      "favicon": "Favicon",
      "coverImage": "Imagem da capa",
      "logo": "Logótipo",
      "invalidFileFormat": "Ups! Formato/Tipo de ficheiro inválido.",
      "pleaseUploadImageType": "Tipos de documento suportados: {types}"
    },
    "groupAppearance": {
      "description": "o utilizador pode Configurar o seu Grupo Aparência conforme a sua escolha aqui",
      "slug": "Atualize o seu Grupo Aparência aqui",
      "colorMode": "Modo de Cor",
      "previewTheLook": "Pré-visualizar como o seu Grupo irá Aparência in modo Claro e Escuro",
      "light": "Claro",
      "dark": "Escuro",
      "communityTheme": "Tema da comunidade",
      "customTheme": "Tema Personalizado",
      "windowGradient": "Gradiente da Janela",
      "applyGradientColorsToYourSidebarAndTopbar": "Aplicar cores de Gradiente à sua barra lateral e à barra superior",
      "labels": {
        "sidebarBackground": "Fundo da barra lateral",
        "primary": "PRIMÁRIO",
        "secondary": "Secundário",
        "tertiary": "Terciário",
        "surface": "Revestimento",
        "fontPrimary": "Tipo de letra PRIMÁRIO",
        "fontSecondary": "Tipo de letra alternativo",
        "fill": "Cor de Preencher",
        "border": "Limite",
        "error": "Erro",
        "background": "Fundo",
        "option": "Opção"
      },
      "customThemes": {
        "default": "Predefinição",
        "zestyCitrus": "Cinzento Cítrico",
        "royalVelvet": "Veludo real",
        "sunnyDelight": "Praticidade ensolarada",
        "lushMeadow": "Suplemento Prado",
        "azureDreams": "Azul Sonhos",
        "bubblegumBliss": "Webinar",
        "ivoryWhisper": "Sussurro de Marfim",
        "midnightDeep": "Meia-noite no fundo"
      },
      "unsavedChanges": "Dinâmico não guardado",
      "unsavedChangesMessage": "o utilizador tem o Tema Dinâmico não guardado, tem a certeza de que o utilizador pretende Anular o Dinâmico?"
    },
    "promotionalLinks": {
      "promotionalLinks": "Ligações promocionais",
      "createPromotionalLinkDescription": "Crie Ligações promocionais para a sua Coleção",
      "addPromotionalLink": "Adicionar ligação",
      "deleteLink": "Eliminar Link",
      "deleteLinkConfirmation": "Tem a certeza de que pretende eliminar esta ligação?",
      "labels": {
        "description": "Descrição",
        "url": "URL",
        "private": "Privado",
        "privateLinksDescription": "Ligações privadas são visíveis apenas para membros do grupo"
      },
      "placeholders": {
        "enterLinkDescription": "Insira a descrição do link",
        "enterLinkURL": "Introduza o Url da ligação"
      },
      "addPromotionalLinkDescription": "Criar Ligações promocionais para o seu Grupo",
      "ariaLabels": {
        "editLink": "Editar ligação",
        "deleteLink": "Eliminar ligação"
      }
    },
    "membershipQuestions": {
      "addQuestion": "Adicionar Questão",
      "editQuestion": "Editar Questão",
      "editLevelName": "Editar nome do nível",
      "addOption": "Adicionar Opção",
      "level": "Nível",
      "name": "Nome",
      "addMembersQuestionsDescription": "Adicione perguntas aos membros para fazer quando eles solicitarem acesso ao seu grupo",
      "enableMembershipQuestions": "Ativar Perguntas sobre Assinatura",
      "membershipQuestions": "Dúvidas sobre a Associação",
      "deleteQuestion": "Excluir Questão",
      "deleteQuestionConfirmation": "Tem a certeza de que pretende eliminar esta pergunta?",
      "labels": {
        "textBox": "Caixa de texto",
        "singleSelect": "Seleção única",
        "multipleSelect": "Seleção múltipla",
        "enableMembershipQuestions": "Adicionar pelo menos um Questão às perguntas da Ativar Associação"
      },
      "validations": {
        "questionRequired": "Insira a pergunta",
        "answerOptionsRequired": "É necessário um mínimo de duas opções, que devem ser únicas",
        "somethingWentWrong": "Algo correu mal. Tente novamente mais tarde.",
        "updatedQuestions": "Perguntas Atualizadas sobre Assinatura ao Grupo",
        "levelNameRequired": "Insira o nome do nível",
        "updatedLevelName": "Nome do nível atualizado"
      },
      "placeholders": {
        "enterLevelName": "Nome do nível",
        "selectOne": "Selecionar um",
        "keepItShort": "Mantenha-o curto.",
        "exampleOffer": "por exemplo 10% Desativado Ativado primeira compra"
      },
      "privacyNotice": "Compreendo que as minhas respostas serão Arquivo e visíveis para os administradores do Grupo.",
      "ariaLabels": {
        "editQuestion": "Editar pergunta",
        "deleteQuestion": "Eliminar pergunta"
      }
    },
    "gamificationAndRewards": {
      "title": "Personalizar Níveis e Recompensas",
      "description": "Personalize os nomes dos Planos e adicione recompensas para um melhor envolvimento dos Membros",
      "gamification": "Gamificação",
      "rewards": "Recompensas",
      "addRewards": "Adicionar Recompensa",
      "ariaLabels": {
        "toggleGamification": "Alternar Opções de Gamificação"
      }
    },
    "invitations": {
      "invitationSentSuccessfully": "Convite enviado com sucesso",
      "invitationSentSuccessfullyDescription": "Convite enviado para {email}",
      "shareGroupLink": "Partilhe o link do seu grupo",
      "inviteMember": "Convidar membro",
      "inviteMemberDescription": "Construa a sua comunidade convidando um novo membro",
      "inviteViaEmail": "Convidar por Email",
      "invitedMembersWillBeAutoApproved": "Os membros convidados serão aprovados automaticamente para ingressar no grupo",
      "sendInvite": "ENVIAR CONVITE",
      "permissionDenied": "o utilizador não tem Autorização para convidar Membros. Por favor, contacte o seu administrador.",
      "labels": {
        "giveAdministrativePrivileges": "Conceder privilégios administrativos",
        "giveAdministrativePrivilegesDescription": "Ativar este membro para executar todas as ações administrativas",
        "name": "Nome",
        "email": "E-mail",
        "nameLabel": "Nome",
        "emailLabel": "E-mail"
      },
      "placeholders": {
        "enterName": "Introduzir nome",
        "enterEmail": "Introduzir e-mail"
      }
    },
    "groupDetails": {
      "updateGroupDetails": "Atualizar detalhes do Grupo",
      "updateGroupDetailsDescription": "Atualize os detalhes do seu grupo aqui",
      "slugNotAvailable": "Slug do Grupo Não Disponível",
      "description": "Elaborar a natureza dos debates que terão lugar no seio do grupo",
      "publicDescription": "Qualquer pessoa pode ver as postagens do grupo e outros membros do grupo",
      "privateDescription": "Apenas os Membros podem ver as postagens da Coleção e outros Membros da Coleção",
      "accessibleFromSwitcher": "Abrir a partir do Comutador",
      "accessibleFromSwitcherDescription": "O seu grupo estará visível para não membros do grupo no Comutador",
      "allowMembersToInvite": "Ativar Membros para convidar novo Membros",
      "allowMembersToInviteDescription": "Ocultar o Botão de convite para Membros Quando ligado Desativado. Os Membros só podem convidar Outros Se este é o Ativado.",
      "showMandatoryInfoModal": "Mostrar modal de perfil obrigatório",
      "showMandatoryInfoModalDescription": "Quando ativado, será pedido aos membros que completem as informações do respetivo perfil quando aderirem ao grupo.",
      "slug": "Grupo Slug",
      "discovery": {
        "title": "Descoberta",
        "description": "Seja encontrado por milhões de Utilizadores ativos. A Coleção estará visível na página de Descobrir assim que tiver mais de 10 Membros.",
        "discoverChannels": "Descobrir canais",
        "joinGroupToExploreAllChannels": "registar-se o Grupo para explore todos os canais",
        "categoryIsUsedOnlyOnGokollab": "A categoria é utilizada apenas no Gokollab",
        "categoryAutomaticallySuggested": "A categoria é sugerida automaticamente utilizando AI com base no título e na descrição do seu grupo. Para obter a sugestão mais precisa, certifique-se de que os detalhes do seu grupo refletem claramente o seu objetivo e tópicos.",
        "categoryRefreshLimited": "A atualização da categoria é limitada a uma vez em cada 24 horas"
      },
      "placeholders": {
        "description": "Introduzir uma breve descrição"
      },
      "validations": {
        "nameRequired": "Insira um nome de grupo válido!",
        "slugRequired": "Insira um slug de grupo válido!",
        "specialCharacterNotSupported": "Caractere especial não suportado",
        "descriptionRequired": "A descrição do grupo é obrigatória!",
        "emailRequired": "Insira um e-mail válido!",
        "fullNameRequired": "Insira um nome válido!"
      },
      "labels": {
        "groupName": "Nome do Grupo"
      }
    },
    "subscriptions": {
      "manageSubscriptions": "Gerir a sua Assinatura",
      "viewAndManageGroupSubscriptions": "Ver e Gerir Grupo Assinatura",
      "paymentIntegrationMissingMessage": "Integre os pagamentos in Localização para o Ativar Pago Grupo",
      "price": "Preço",
      "currency": "Moeda",
      "priceDisplay": "{symbol}{price}{suffix}",
      "priceInterval": "/{interval}",
      "oneTime": " Um dado",
      "priceDeletedAlert": "O produto de pagamento é De Sincronização, clicando aqui para re sincronizar",
      "intervals": {
        "month": "Mês",
        "year": "Ano",
        "week": "Semana",
        "day": "Dia"
      },
      "addNewPrice": "Adicionar novo Preço",
      "editPrice": "Editar Preço",
      "addPrice": "Adicionar Preço",
      "subscriptionType": {
        "recurring": "Recorrente",
        "oneTime": "Um dado"
      },
      "billingPeriod": {
        "monthly": "Mensal",
        "annually": "Anual",
        "weekly": "Semanal",
        "daily": "diário"
      },
      "ariaLabels": {
        "freeMembership": "Botão de rádio de associação gratuita",
        "paidMembership": "Botão de Rádio de associação paga"
      }
    },
    "menuOptions": {
      "details": "Detalhes",
      "subscriptions": "Assinatura",
      "branding": "Marca",
      "themes": "Tema",
      "tabsConfiguration": "Mostrar / Ocultar Separadores",
      "membershipQuestions": "Dúvidas sobre a Associação",
      "gamificationAndRewards": "Gamificação e recompensas",
      "links": "Ligações",
      "newsletter": "Newsletter",
      "reportedContent": "Conteúdo relatado",
      "discovery": "Descobrir",
      "import": "Importar"
    },
    "newsletter": {
      "title": "Newsletter",
      "subheading": "O Seu Resumo da Comunidade",
      "frequency": "Frequência da Newsletter",
      "description": "Um Resumo das publicações populares, Atividade dos Membros e ocorrências deste Grupo",
      "selectFrequency": "Selecionar frequência",
      "frequencies": {
        "off": "Desativado",
        "daily": "Diariamente",
        "weekly": "Semanalmente",
        "biweekly": "Quinzenal",
        "monthly": "Mensalmente"
      }
    },
    "tabConfiguration": {
      "title": "Mostrar/ocultar separadores",
      "description": "Controle os separadores que aparecem na sua comunidade. Ative ou desative cada separador para criar uma experiência focada e simplificada para os seus membros.",
      "discussionDescription": "Inicie ou participe em conversas para partilhar atualizações, ideias e estatísticas com a sua comunidade.",
      "learningDescription": "Crie e faça a gestão de cursos que ajudam os membros a adquirir novas competências ou conhecimentos.",
      "eventsDescription": "Planeie, organize e visualize as próximas sessões, workshops ou eventos comunitários.",
      "leaderboardDescription": "Reconheça os membros com o melhor desempenho e incentive uma interação saudável através de classificações.",
      "membersDescription": "Faça a gestão de todos os membros e funções. Este separador permanecerá visível para os administradores mesmo quando desativado, para que a gestão de membros esteja sempre acessível.",
      "aboutDescription": "Apresente o propósito, os valores e o histórico da sua comunidade para ajudar os membros a conectarem-se.",
      "discussionTooltip": "O separador Discussão é uma parte essencial da comunidade e não pode ser desativado",
      "aboutTooltip": "O separador \"Sobre\" é necessário para fornecer informações essenciais da comunidade e não pode ser desativado."
    },
    "groupSettings": {
      "groupSettings": "Definições do Grupo",
      "changeGroupType": "Alterar Tipo de Grupo",
      "changeGroupTypeDescriptionPrivateToPublic": "Dinâmico para um Público Grupo significa que todos os Pedidos Pendentes serão Aceite automaticamente e o Conteúdo ficará visível ao público. Prosseguir?",
      "changeGroupTypeDescriptionPublicToPrivate": "Dinâmico para um Grupo Privado significa que os novos Membros precisam de Aprovação e o Conteúdo fica Oculto até serem Aceite. Prosseguir?",
      "changeGroupTypeConfirmation": "Tem a certeza de que o utilizador pretende Alterar Grupo Tipo?",
      "changeGroupTheme": "Alterar Tema do Grupo",
      "changeGroupThemeDescription": "Isto irá Alterar o Tema para todos os Grupo Membros. Tem a certeza de que o utilizador pretende Alterar Grupo Tema?",
      "updatedGroupDetails": "Detalhes do Grupo Atualizado",
      "unableToSaveDetails": "Ups! Não é possível Arquivar Detalhes.",
      "groupNameIsRequired": "O nome do grupo é Necessário",
      "groupDescriptionIsRequired": "Grupo Descrição é Necessário",
      "groupSlugIsRequired": "O Grupo Slug é Necessário",
      "groupSlugMustContainOnly": "O Grupo Slug deve conter apenas letras Minúsculas, Quantidade e hífens",
      "groupSlugAlreadyExists": "O Slug do Grupo já existe. Utilize um Slug diferente, pois este já está a ser utilizado",
      "groupSlugRestricted": "Este Slug corresponde a uma das nossas Palavras-chave Privadas para links da comunidade. Utilize um slug diferente",
      "pleaseTryAgainLater": "Por favor, tentar novamente mais tarde",
      "unsavedChangesMessage": "o utilizador tem o Grupo Slug Dinâmico não guardado, tem a certeza de que o utilizador pretende Anular?"
    },
    "import": {
      "header": "Importar Membros do Grupo Skool e respetivo Conteúdo",
      "credentialDescription": "Introduza o seu Certificado Skool para Importar o seu Grupo Membros e o seu Conteúdo",
      "csvUploadDescription": "Selecionar .csv Ficheiro para importar contactos De Skool",
      "loginFailed": "O utilizador introduziu uma password inválida E-mail ou . Por favor, tentar novamente.",
      "proceedWithImport": "Prosseguir com a Importar?",
      "iAgree": "Aceito",
      "importTerms": "Ao clicar em \"Aceito\", o utilizador confirmar e aceitar que o utilizador nos contratou como um Negócio independente para executar os Serviços Ativado por si (\" Serviços \"). Os Serviços Incluir a Transferência de alguns dados, Detalhes, Conteúdo, Propriedades Inteligentes Ou quaisquer Outros Conteúdo (\" Informações \") De uma Conta da Plataforma do Emitedo para uma Conta da Plataforma Recebida. o utilizador representam e asseguram que (i) o utilizador é o Proprietário válido das Informações in Plataforma do Emido Conta, (ii) o utilizador tem as Permissões para nos conceder o Acesso à Plataforma do Emido Conta para a Intenção de executar os Serviços, e (iii) a Transferir das Informações não irá infringir quaisquer Propriedades Inteligentes de terceiros Permissões ou Viola quaisquer contratos de terceiros. o utilizador concorda em indemnizar, defender e colocar em espera, suspender-nos inócuos para quaisquer reclamações de terceiros que possam ocorrer como Resultado da sua violação dos relatórios e garantias acima.",
      "pleaseDownloadCSV": "Descarregue o .CSV Ficheiro",
      "step01": "Passo 01-",
      "step02": "Passo 02-",
      "uploadCSV": "Carregar o seu .CSV",
      "step01Description": "Preencher in Ou atualize quaisquer detalhes em falta para os Membros do Grupo , como Gmail, nome próprio , etc. Certifique-se de que o CSV é carregado in",
      "thisTemplate": "este Modelo",
      "importCSV": "Importar .CSV",
      "reSyncData": "ReSincronize os seus dados Antes de Descarregar.",
      "refreshUserList": "Atualizar lista do utilizador",
      "reSyncDataDescription": "Se novo Utilizador for adicionado, in , recomendamos que atualize a sua Lista e descarregue o CSV.",
      "pleaseDontChangeProfileSlug": "Por favor, não Alterar Perfil Slug.",
      "selectFile": "Selecionar Ficheiro",
      "changeFile": "Alterar Ficheiro",
      "importMembersFailedText": "Isso pode ocorrer porque não tem o endereço de e-mail. Marque de verificação o seu Importar Ficheiro e Tentar novamente com um endereço de e-mail válido para estes Membros.",
      "upload": "Carregar",
      "tryAgain": "Tentar novamente",
      "importerAnotherGroup": "Iniciar nova importação",
      "syncAllPosts": "Sincronização toda a sua História e Comentário",
      "membersCouldNotBeAdded": "Não foi possível adicionar Membros ao Grupo.",
      "importMembersSuccess": "Enviamos um e-mail a todos os Membros Individual do Grupo, confirmar a sua Associação in Grupo e fornecer-lhes Acesso Detalhes. Isto ajuda a manter a certeza de que todos os Membros estão informados e podem aceder ao Grupo de forma eficaz.",
      "importMembersAdded": "Os Membros foram adicionados com sucesso ao Grupo",
      "postsNotSynced": "As Publicações restantes não podem ser Sincronização para o Grupo. Isso pode ocorrer porque a História Autores não foi importada com sucesso.",
      "migrationFailed": "Falha na migração. Por favor, tentar novamente.",
      "migrationCompleted": "Migração concluída!",
      "migrationInProgress": "Migração em curso",
      "createProfile": "Criar perfil",
      "enterCredentials": "Introduzir credenciais",
      "uploadingInProgress": "Carregamento in curso!",
      "listMembers": "A Lista de Membros está a ser",
      "downloaded": "Descarregar",
      "uploaded": "carregado",
      "listPostsDownloaded": "A Lista de publicações está Descarregar.",
      "listPostsDownloading": "A Lista de postagens está a ser Descarregar.",
      "posts": "publicações",
      "members": "Membros",
      "imported": "importado",
      "step1": "Passo 1",
      "step2": "Passo 2",
      "step1Description": "Criar um Membros Perfil in Skool Grupo.",
      "step1Description2": "(incluindo Nome, Id do E-mail e Senha)",
      "step2Description": "Insira o Skool Membros Certificado",
      "skoolUrlPlaceholder": "Introduza o URL do grupo da sua Skool",
      "emailPlaceholder": "Introduza Iddo e-mail do seu Skool",
      "emailTooltip": "Insira o e-mail Membros com a sua Conta Skool",
      "passwordPlaceholder": "Introduza a palavra-passe do seu Skool",
      "confirm": "Confirmar",
      "validation": {
        "skoolUrl": "Introduza um URL válido do Skool",
        "email": "E-mail é necessário",
        "password": "A palavra-passe é necessária"
      }
    },
    "approved": "Aprovado",
    "pending": "Pendente",
    "rejected": "Recusado"
  },
  "invitations": {
    "intent": "Ajude esta comunidade a crescer!",
    "cancelInvitation": "Cancelar convite",
    "inviteMembers": "Convide membros para colaborar nesta comunidade.",
    "inviteLink": "Link de convite",
    "invitationLink": "ligação de convite",
    "buildYourCommunity": "Construa a sua comunidade!",
    "inviteMembersToCollaborate": "Criou uma nova comunidade! Convide membros para colaborar nesta comunidade.",
    "invite": "Convite",
    "basicInformation": "Informações básicas",
    "permissions": "Permissões"
  },
  "createPost": {
    "title": "Criar nova publicação de blog",
    "placeholder": "O que está na sua mente",
    "liveStream": "Transmissão em direto",
    "slug": "Publicação no blogue do PURL do Slug",
    "titleHelp": "O Título, a Descrição e a Fotografia serão utilizados para a meta etiqueta SEO",
    "nameLabel": "Título da publicação no blogue",
    "nameValidation": "O título é obrigatório",
    "descriptionLabel": "Descrição da publicação",
    "descriptionHelp": "Dê uma breve descrição para que os espectadores tenham uma ideia da publicação. Funciona melhor entre 100 e 250 caracteres",
    "descriptionValidation": "A descrição é obrigatória",
    "createLabel": "Criar publicação",
    "image": "Imagem da publicação no blogue",
    "imageDescription": "O tamanho recomendado é 600px * 400px",
    "notificationTitle": "Criação da publicação no blogue",
    "notificationErrorTitle": "Falha na criação da publicação no blogue",
    "postingIn": "Publicar in",
    "editingIn": "Editar in"
  },
  "post": {
    "downloadRecording": "Descarregar Gravação",
    "deletePost": "Eliminar publicação",
    "reportPost": "Denunciar publicação",
    "editPost": "Editar publicação",
    "createPost": "Criar postagem",
    "publish": "Publicar",
    "publishPost": "Publicar Postagem",
    "addChannel": "Adicionar canal",
    "selectChannel": "Selecione o canal",
    "addLink": "Adicionar ligação",
    "removeLink": "Remover Link",
    "update": "Atualizar",
    "unsavedChanges": "Tem alterações não guardadas",
    "unsavedChangesMessage": "As suas alterações não guardadas serão perdidas. Ainda quer continuar?",
    "unpinFromChannel": "Desaperte",
    "unpinFromHome": "Desaperte",
    "deletePostConfirmation": "Tem a certeza de que pretende eliminar esta publicação?",
    "reportPostConfirmation": "Tem certeza de que deseja denunciar esta publicação?",
    "postNotFound": "Partilhar não encontrado",
    "postNotFoundMessage": "A publicação que está a tentar ver foi eliminada ou não existe.",
    "loadMoreComments": "Carregar mais comentários",
    "channelNotFound": "Canal não encontrado",
    "isCurrentlyLive": "está agora ao vivo",
    "isStartingNow": "está a começar agora",
    "isHappeningInMinutes": "está a acontecer em {minutes} minutos",
    "isHappeningInHours": "está a acontecer in {hours} hora | está a acontecer in {hours} hora",
    "publicChannel": "Canal público",
    "privateChannel": "Canal privado",
    "featured": "Em destaque",
    "featuredAbout": "Sobre em destaque",
    "noPostsFound": "Nenhum post encontrado",
    "pinInfo": "O utilizador pode fixar itens a serem exibidos no Topo da Coleção, incluindo publicações, regras e hashtags.",
    "pinInfoEveryone": "Todos os membros do grupo irão ver estes itens.",
    "pinInfoRemainVisible": "Os itens fixados permanecem visíveis até que os desprenda.",
    "pinInfoNewestItem": "À medida que fixa itens, o item mais recente aparece na frente da lista.",
    "onlyVisibleToAdmins": "Apenas visível para os administradores",
    "featuredAboutDescription": "Os seus administradores fixaram esses itens para a Coleção ver.",
    "channelNotFoundMessage": "Já não é membro do canal a que está a tentar aceder ou o canal foi eliminado.",
    "notifications": {
      "unpinned": "Desafixado!",
      "pinned": "Fixado!",
      "reported": "A publicação foi denunciada!",
      "error": "Algo correu mal!",
      "isCommentDisabled": "Comentários desativados!",
      "isCommentEnabled": "Comentários ativados!"
    },
    "movePostToChannel": "Mover para o canal",
    "pin": "Fixar",
    "pinToHome": "Fixar na página inicial",
    "pinToChannel": "Fixar no canal",
    "whatIsYourTitle": "Qual é o seu Título?",
    "postMovedToChannel": "História movida para o canal {channelName}",
    "upcomingEvent": "Evento futuro",
    "turnOffCommenting": "Desativar comentários",
    "enableComments": "Ativar comentários",
    "disableComments": "Desativar Comentários",
    "moveToPrivateChannelConfirmation": {
      "title": "Mover para Canal Privado",
      "message": "Utilizador está prestes a Passo esta Partilhar para um Canal Privado. Apenas os Membros desse Canal Privado poderão vê-lo. Pretende continuar?"
    },
    "onlyAdminsCanPost": "Apenas os administradores da comunidade podem Partilhar neste Canal."
  },
  "reaction": {
    "noLikes": "Sem Gostos",
    "andOthers": "e {count} outros"
  },
  "UIConfirmation": {
    "privateGroup": "Este grupo é privado",
    "privateGroupMessage": "O utilizador tem de ser membro desta coleção para aceder a informações específicas do grupo. Solicite acesso clicando no Botão \"Registar-se na Coleção\"."
  },
  "notifications": {
    "noNotificationsYet": "Ainda sem notificações",
    "whenYouGetNotifications": "Quando receber notificações, elas serão mostradas aqui",
    "markAllAsRead": "Marcar todos como lidos",
    "notifications": "Notificações",
    "all": "Todos",
    "unread": "Não lido",
    "checkNotifications": "Inicie sessão para verificar as notificações",
    "noNotifications": "Sem notificações!",
    "redirectedFromOldSlug": {
      "title": "Foi redirecionado para a ligação atualizada da comunidade",
      "content": "Isto foi Concluído para melhorar o desempenho de SEO para esta comunidade. Por favor, atualize os seus favoritos com este novo URL."
    }
  },
  "joinGroupModal": {
    "wahoo": "Wahoo! 🎉, Pedido enviado com sucesso",
    "reviewRequestSoon": "Os nossos administradores de grupo analisarão o seu pedido em breve. Seja paciente e nós o notificaremos assim que a sua Assinatura for Aceite.",
    "nonMemberMessage": "Tem de fazer parte desta Coleção para Gosto e comentar as postagens",
    "subscribeFor": "Subscreva para",
    "joinGroup": "JUNTE-SE AO GRUPO",
    "membershipPending": "Associação PENDENTE",
    "viewMembershipAnswers": "Ver respostas de Associação",
    "requested": "Solicitado",
    "dayFreeTrial": "Teste Grátis de um Dia",
    "notPartOfGroup": "O utilizador não faz parte deste Grupo ainda, a sua Associação Pedidos está in Revisão. Uma vez que um Administrador Aceite os seus Pedidos, nós notificaremos o utilizador",
    "pleaseAnswerMembershipQuestions": "Responder às perguntas da Associação para registar-se este Grupo",
    "answerQuestions": "Responder perguntas de associação"
  },
  "userProfilePopover": {
    "active": "Ativo",
    "longAgo": "há muito tempo",
    "chatDisabled": "Este Utilizador desativou o seu chat",
    "pointsToLevelUp": "pontos para subir de nível",
    "profile": "Perfil",
    "deletedUser": "Utilizador eliminado",
    "joined": "Aderiu",
    "contributions": "Contribuições"
  },
  "courses": {
    "by": "Por",
    "free": "Grátis",
    "unknownInstructor": "Instrutor Desconhecido",
    "courseRestricted": "Esta Rota é Privado",
    "courseDeleted": "Este curso foi eliminado.",
    "noMatchingCourseFound": "Nenhum curso correspondente encontrado",
    "addCourse": "Adicionar curso",
    "updateCourse": "Curso de Atualização",
    "access": "Todos os Membros têm acesso",
    "unableToAddCourse": "Ups! Não foi possível adicionar o curso.",
    "pleaseTryAgainLater": "Tente novamente mais tarde",
    "paymentIntegrationMissing": "Ups! Falta integração de pagamentos",
    "paymentIntegrationMissingMessage": "Integre os pagamentos na Localização para ativar Cursos pagos",
    "course": "Curso",
    "courseInThisGroup": "um curso existente nesta Coleção",
    "courseLinkCopied": "Hiperligação do curso Copiada!",
    "buyNow": "COMPRE AGORA",
    "locked": "Bloqueado",
    "buyCourse": "COMPRAR CURSO",
    "open": "ABERTA",
    "moveCard": "Passo o cartão",
    "courseViewMessage": "Tem de fazer parte desta Coleção para Ver os Cursos.",
    "deleteCourse": "Eliminar curso",
    "deleteCourseConfirmation": "Tem a certeza de que pretende eliminar este curso?",
    "courseAccessNotGranted": "Acesso ao curso não concedido",
    "courseAccessNotGrantedMessage": "No momento, estamos a trabalhar para conceder-lhe acesso ao curso. Atualize a página e tente novamente daqui a pouco.",
    "autoRenewsAfter": "Renova automaticamente depois de",
    "oneTimePayment": "Pagamento único",
    "emptyCoursesMessage": "Parece uma cidade fantasma. Não há nada para ver aqui",
    "updatedSuccessfully": "Curso atualizado com sucesso",
    "addedSuccessfully": "Curso adicionado com sucesso",
    "createCourse": "Criar Novo Curso",
    "emptyCourseLibrary": "A sua biblioteca de cursos está vazia!",
    "createdOutsideGokollabMessage": "Esta comunidade foi criada fora de Gokollab & e tornou-se visível. Para Gerar novos Cursos, inicie sessão na comunidade De a sua Fonte Canal.",
    "createCourseOnGokollabMessage": "Gerar um novo Rota Ativado Gokollab para Criar-o aos Membros da sua comunidade.",
    "or": "ou",
    "createNewOne": "criar um novo",
    "labels": {
      "selectCourse": "Selecione o curso",
      "courseVisibility": "Visibilidade do curso",
      "courseAccess": "Acesso ao curso",
      "coursePrice": "Preço do curso",
      "subscriptionType": "Tipo de Assinatura",
      "billingPeriod": "Período de faturação",
      "testMode": "Modo de teste",
      "turnOnTestPayments": "Ative os pagamentos de teste usando um cartão de teste",
      "currency": "Moeda",
      "trialDays": "Dias de avaliação",
      "recurring": "Recorrente",
      "free": "Grátis",
      "oneTime": "Um dado",
      "refresh": "Atualizar",
      "accessStartsAtDay": "O Acesso começa no Dia",
      "maximumYouCanEnterIs365": "O máximo utilizador pode introduzir é de 365",
      "allMembers": "todos Membros Membros",
      "levelUnlock": "Uniforme Desbloqueio",
      "buyNow": "Comprar agora",
      "timeUnlock": "Desbloqueio de dados",
      "gamificationLevel": "Gamificação Uniforme",
      "privateChannel": "Canal Privado",
      "private": "Privado",
      "marketingChannel": "Canal de Marketing",
      "selectCurrency": "Selecionar moeda"
    },
    "placeholders": {
      "enterPrice": "Insira o preço",
      "enterTrialDays": "Insira os dias de avaliação",
      "selectCurrency": "Selecionar um",
      "selectBillingPeriod": "Selecionar um",
      "billingPeriod": "Selecionar período de faturação"
    },
    "validations": {
      "validPrice": "Insira um preço válido",
      "required": "Selecione um curso",
      "validMembershipPrice": "Insira um preço de adesão válido",
      "validTrialDays": "Introduza dias de teste válidos",
      "requiredSubscriptionType": "Selecione o tipo de Assinatura",
      "courseVisibility": "Selecione a Visibilidade do curso",
      "requiredGamificationLevel": "Por favor, selecione a Gamificação Uniforme",
      "requiredPrivateChannel": "Selecione o canal Privado",
      "validAccessStartDay": "Insira um dia de início de Acesso válido"
    },
    "descriptions": {
      "buyNowDescription": "Este curso é Público no momento da compra",
      "timeUnlockDescription": "Membros Desbloquear Depois de X dias",
      "levelUnlockDescription": "Os Membros apenas com um certo Uniforme poderão desbloquear",
      "allMembersDescription": "todos os Membros têm Acesso a este curso",
      "privateChannelDescription": "Membros de um canal Privado",
      "privateDescription": "Acesso concedido apenas pelo administrador"
    },
    "helperText": {
      "levelBased": "Com base no nível",
      "timeLimited": "hora- Limitada",
      "privateBased": "Privado",
      "free": "Grátis",
      "levelAvailableAt": "Disponível no Uniforme 0{value}",
      "timeLimitedAfterJoining": "Público {value} {day} Depois de se juntar ao Grupo",
      "day": "Dia",
      "days": "dias",
      "purchaseToUnlockAccess": "Compre este curso para desbloquear o Acesso",
      "privateCourse": "Curso privado - Acesso concedido apenas pelo administrador",
      "locked": "Este curso está bloqueado",
      "unlockAtLevel": "Este curso será desbloquear no Uniforme {level}",
      "unlockAfterDays": "Este curso irá desbloquear Depois de {days} {dayText}",
      "privateChannelBased": "Com base em Canal Privado",
      "externalAccess": "Outro Grupo/Oferta"
    },
    "manageAccess": {
      "manageCourses": "Gerir Cursos",
      "revokeCourseAccess": "Gerir Cursos",
      "grantCoursesAccess": "Atribuir cursos",
      "removeAccess": "Remover acesso",
      "grantAccess": "Atribuir acesso",
      "grant": "Conceder",
      "clear": "Limpar",
      "selectAll": "Selecionar tudo",
      "revokeAccessConfirmTitle": "Remover acesso ao curso?",
      "revokeAccessConfirmMessage": "Tem a certeza de que pretende remover o acesso a \"{courseName}\" para {userName}?",
      "externalAccessTooltip": "Não é possível remover: o utilizador tem acesso a partir de outro grupo ou oferta",
      "cannotRevokeAutoAccess": "Não é possível remover: o acesso é atribuído automaticamente com base nas definições do curso (pago, nível, tempo ou grátis)",
      "searchPlaceholder": "Pesquisar por cursos",
      "noCoursesFound": "Nenhum curso encontrado",
      "noCoursesSelected": "Ainda não foi selecionado nenhum curso",
      "noCoursesAvailable": "Não há cursos disponíveis para atribuir",
      "noSearchResults": "Sem resultados da pesquisa",
      "failedToLoadCourses": "Falha ao carregar cursos",
      "accessRevoked": "Acesso ao curso removido com sucesso",
      "failedToRevokeAccess": "Falha ao remover o acesso ao curso",
      "accessGranted": "Acesso ao curso atribuído com sucesso",
      "multipleAccessGranted": "{count} cursos atribuídos com sucesso",
      "failedToGrantAccess": "Falha ao atribuir acesso ao curso"
    },
    "ariaLabels": {
      "courseCard": "Cartão de curso",
      "courseCardActions": "Ações do cartão de curso",
      "editCourse": "Editar curso",
      "deleteCourse": "Eliminar curso",
      "moveCard": "Mover cartão",
      "copyLink": "Copiar ligação",
      "cardImage": "Imagem do cartão de curso"
    }
  },
  "about": {
    "notifications": {
      "errorUploadingFile": "Erro ao carregar ficheiro"
    },
    "uploadLinkVideo": "Carregar/ligar vídeo",
    "removeMedia": "Remover multimédia de {fileName}"
  },
  "leaderboard": {
    "level": "Nível",
    "lastUpdated": "Última atualização",
    "members": "Membros",
    "percentOfMembers": "{percentage}% dos membros",
    "rewards": "Recompensas",
    "allTime": "Todos os tempos",
    "pointsToLevelUp": "pontos para subir de nível",
    "points": "Pontos",
    "leaderboard7d": "Tabela de classificação (7 dias)",
    "leaderboard30d": "Tabela de classificação (30 dias)",
    "leaderboardAlltime": "Tabela de Líderes (Todos os tempos)",
    "yourRank": "A sua classificação",
    "noActivityToShow": "Nenhuma atividade para mostrar",
    "rewardsWillBeDisplayedHere": "As recompensas serão exibidas aqui",
    "seeAllLeaderboards": "Ver todas as tabelas de classificação",
    "addRewards": "Adicionar Recompensas",
    "howPointsWork": "Ganha Pontos quando outros Membros fazem Gosto nas suas postagens ou comentários. 1 Gosto = 1 Ponto. Isto incentiva os Utilizadores a gerar conteúdo de qualidade e a interagir com outros Membros da sua comunidade.",
    "levels": "Níveis",
    "levelsDescription": "À medida que ganha pontos, sobe de nível. O seu nível é mostrado no canto inferior direito do seu avatar. O número de pontos necessários para passar para o nível seguinte é mostrado via a Barra de progresso na página da Tabela de classificação.",
    "pointsAndLevels": "Pontos & Camadas"
  },
  "events": {
    "createEvent": "Criar evento",
    "dragAndDrop": "Arrastar e soltar um SVG, PNG ou JPG (Max 800 x 400px)",
    "editEvent": "Editar evento",
    "addEvent": "Adicionar evento",
    "paymentDetails": "Detalhes do pagamento",
    "event": "Evento",
    "goBack": "Voltar atrás",
    "cancelEdit": "Cancelar Editar",
    "cancelEvent": "Cancelar evento",
    "next": "Seguinte",
    "saveEvent": "Guardar Evento",
    "editRecurringEvent": "Editar evento recorrente",
    "thisEvent": "Este evento",
    "thisAndFollowingEvents": "Este e os seguintes eventos",
    "ok": "OK",
    "deleteRecurringEvent": "Eliminar evento recorrente",
    "allEvents": "Todos os eventos",
    "adminsFreeForPaidEvents": " * Os administradores podem registar-se no Pago Eventos para Grátis",
    "deleteEvent": "Eliminar evento",
    "onceEventDeleted": "Depois de o evento ser Eliminado, não aparecerá no seu calendário.",
    "toRegister": "para se registar",
    "calendar": "Calendário",
    "addToCalendar": "Adicionar ao calendário",
    "declineRegistration": "Recusar",
    "paymentFailedMessage": "O seu pagamento falhou devido a algumas circunstâncias imprevistas! Tente novamente mais tarde.",
    "upcoming": "Em breve",
    "noMoreEvents": "Não há mais ocorrências para mostrar",
    "joinGroupToRegister": "O utilizador precisa de fazer parte desta Coleção para se inscrever neste Evento",
    "past": "Passado",
    "youHaveRegisteredForOneEvent": "Registou-se para 1 evento. Vamos enviar-lhe um lembrete um dia antes de cada evento.",
    "upcomingEvents": "Eventos futuros",
    "noUpcomingEvents": "Nenhum evento futuro",
    "pastEvents": "Eventos passados",
    "noPastEvents": "Sem Eventos Passados",
    "noMatchingEventFound": "Nenhum evento correspondente encontrado",
    "week": "Semana",
    "month": "Mês",
    "today": "Hoje",
    "registrationConfirmed": "Registo confirmado para {event}.",
    "eventDeletedOrRestricted": "O evento foi eliminado ou restringido",
    "eventDeleted": "O evento foi eliminado",
    "eventRestricted": "Não tem acesso a este evento",
    "validations": {
      "titleValidation": "O título é obrigatório",
      "colorValidation": "A cor é obrigatória",
      "startTimeValidation": "A hora de início é obrigatória",
      "endTimeValidation": "É necessário indicar a hora de fim",
      "endTimeAfterStartTime": "A hora de Fim deve ser depois da hora de início",
      "startTimeMustBeInFuture": "A hora de início deve ser no futuro",
      "locationValidation": "A Localização é Necessário",
      "locationValidationMobile": "Localização é obrig",
      "locationUrlValidation": "É necessário um URL de localização válido",
      "descriptionValidation": "A descrição é obrigatória",
      "descriptionValidationMaxLength": "A descrição não pode exceder 300 caracteres",
      "recaptchaError": "Falha na verificação! Tente novamente",
      "repeatIntervalValidation": "Ocorrência é obrigatória",
      "repeatIntervalValidator": "O intervalo de repetição deve ser Dia, Semana, Mês ou Ano",
      "repeatIntervalRequired": "O Intervalo de Refazer é Necessário",
      "repeatOccurrenceValidator": "A Repetição de Frequência deve ser maior que 0",
      "repeatOccurrenceRequired": "A repetição da ocorrência é Necessária",
      "invalidDateFormat": "Formato de data inválido",
      "endDateMustBeAfterStartDate": "A data de término deve ser posterior à data de início do evento",
      "recurringEndDateValidation": "É necessária uma Data de Término Recorrente",
      "repeatsOnValidation": "Selecione pelo menos um dia",
      "invalidDaySelection": "Seleção de dia inválida",
      "endOptionRequired": "É necessária a opção de fim",
      "levelValidation": "Selecione um nível",
      "courseValidation": "Selecione um curso",
      "channelValidation": "Selecione um canal",
      "eventPriceValidation": "O preço é Necessário e deve ser maior que {min}"
    },
    "placeholders": {
      "selectStartTime": "Selecionar Hora de Início",
      "selectEndTime": "Selecionar Hora de Término",
      "selectLocation": "Selecionar localização",
      "locationUrl": "Link/Morada",
      "description": "Descrição",
      "selectRecurringEndDate": "Selecionar Data de Fim Recorrente",
      "selectDate": "Selecionar data",
      "event": "Evento",
      "selectColor": "Selecione uma cor",
      "selectAttendees": "Selecionar participantes",
      "selectPrivateChannel": "Selecionar Canal Privado",
      "selectCourse": "Selecione o curso",
      "selectLevels": "Selecionar Níveis",
      "selectCalendar": "Selecionar calendário"
    },
    "labels": {
      "startTime": "Hora de início",
      "endTime": "Hora de término",
      "others": "Outros",
      "oneTimePriceForEventRegistration": "Preço único para inscrição no evento.",
      "totalAmount": "Montante Total",
      "cardAuthorizationText": "Ao fornecer as informações do seu cartão, você permite que {locationName} cobre o cartão para pagamentos futuros de acordo com seus termos.",
      "secureAndSafePayments": "Pagamentos 100% seguros e protegidos",
      "day": "Dia",
      "week": "Semana",
      "month": "Mês",
      "year": "Ano",
      "recurringEvent": "O evento será um Evento recorrente?",
      "repeatsEvery": "Repetições a cada",
      "repeatsOn": "Repetições em",
      "end": "Fim",
      "ends": "Fechar",
      "neverEnds": "Nunca acaba",
      "orange": "Laranja",
      "red": "Vermelho",
      "blue": "Azul",
      "green": "Verde",
      "violet": "Violeta",
      "purple": "Roxo",
      "yellow": "Amarelo",
      "title": "Título",
      "color": "Cor",
      "allMembers": "Todos os membros",
      "membersAtALevel": "Membros a um nível",
      "membersOfACourse": "Membros de um curso",
      "membersOfAPrivateChannel": "Membros de um canal privado",
      "whoCanAttendTheEvent": "Quem pode participar do evento?",
      "channel": "Canal",
      "course": "Curso",
      "level": "Nível",
      "remindAttendeesByEmail": "Lembre os participantes por e-mail 1 Dia Antes de",
      "hideLocationFromNonAttendees": "Ocultar a localização de quem não estiver presente.",
      "addChargesToTheEvent": "Adicionar faturação ao Evento",
      "noPaymentRequired": "Nenhum pagamento Necessário",
      "location": "Localização",
      "link": "Ligar, vincular",
      "description": "Descrição",
      "timezone": "Fuso horário",
      "eventType": "Tipo de evento",
      "eventTypeChangeWarning": "Dinâmico para o Tipo de evento Ou os preços serão Aplicar a todas as ocorrências in série.",
      "never": "Nunca",
      "on": "Ativado",
      "after": "Depois de",
      "occurrences": "ocorrências",
      "selectEventEnd": "selecionar Quando o Evento irá Fim.",
      "turnOnTestPayments": "Pagamentos do Inverter Ativado Testar Via de um cartão Testar",
      "pay": "Pagar",
      "hideAttendees": "Ocultar participantes De Grupo Membros",
      "guests": "{count} convidados",
      "guestList": "Lista de Convidado",
      "noAttendees": "Ainda não há participantes",
      "viewAttendees": "Ver participantes",
      "exportAttendees": "Exportar participantes"
    },
    "notifications": {
      "eventCreated": "Evento criado com sucesso!",
      "eventUpdated": "Evento atualizado com sucesso!",
      "eventCreationFailed": "Falha na criação do Evento !",
      "eventUpdateFailed": "Falha na atualização do Evento !",
      "eventDeleted": "Evento eliminado com êxito!",
      "eventDeletionFailed": "Falha ao eliminar o evento!",
      "paymentFailed": "O pagamento falhou!",
      "registrationSuccessful": "Registo bem sucedido!",
      "registrationFailed": "O registo falhou!",
      "addToCalendarFailed": "Falha ao adicionar evento ao calendário!",
      "locationDetailsCopied": "Detalhes da localização copiados para a área de transferência!",
      "registrationDeclined": "O registo foi recusado com sucesso!",
      "registrationDeclinedFailed": "Recusa de registo!",
      "fetchAttendeesFailed": "Falha ao carregar participantes",
      "emailCopied": "Enviar por e-mail Copiado para a área de transferência",
      "exportAttendeesFailed": "Falha ao exportar participantes"
    },
    "selectCalendar": "Selecionar calendário",
    "eventImage": "Imagem do evento",
    "errorLoadingEvent": "Erro ao carregar evento"
  },
  "login": {
    "invite": "convidou o utilizador a registar-se"
  },
  "contentReports": {
    "contentDeleted": "O conteúdo foi excluído!",
    "noActionTaken": "Nenhuma ação tomada no conteúdo reportado!",
    "reportedContentNotFound": "O conteúdo relatado não foi encontrado, pode já ter sido alvo de uma ação.",
    "reported": "Denunciado",
    "viewAllReportedContentHere": "Pode ver todo o conteúdo relatado aqui",
    "takeActionOnReportedContent": "Tomar providências sobre o conteúdo denunciado",
    "andOthers": "e {count} outros",
    "reportedThisPost": "denunciou esta publicação",
    "keep": "MANTER",
    "remove": "REMOVER",
    "deleteContent": "Eliminar conteúdo",
    "deleteConfirmation": "Tem a certeza de que pretende eliminar este conteúdo?",
    "noMemberReportedContent": "Nenhum conteúdo reportado por membros",
    "whenMembersReportPostsOrComments": "Quando os membros denunciam publicações ou comentários, eles aparecem aqui para você analisar. Pode manter ou excluir, bem como suspender, remover ou bloquear os membros que os publicaram.",
    "reportedThisComment": "Denunciou este comentário"
  },
  "contentUnavailable": {
    "thisContentIsntAvailable": "Este conteúdo não está disponível de momento",
    "whenThisHappens": "Quando isto acontece, normalmente é porque o proprietário apenas o partilhou com um pequeno grupo de pessoas ou alterou quem o pode ver, ou foi eliminado"
  },
  "search": {
    "noResultsFor": "0 resultados para \"{query}\" na comunidade",
    "noResultsFound": "Nenhum resultado encontrado"
  },
  "noCommunities": {
    "noCommunitiesFound": "Nenhuma Comunidade Encontrada",
    "startCreatingYourOwnCommunities": "Comece a criar as suas próprias comunidades e envolva-se com o seu público!",
    "noCommunitiesFoundGokollab": {
      "notJoinedA": "Não aderiu a",
      "communities": "Comunidades",
      "yet": "Ainda"
    },
    "noCommunitiesFoundGokollabDescription": "Descobrir espaços onde as pessoas partilham ideias, apoiam-se mutuamente e crescem juntas."
  },
  "noCourses": {
    "noCoursesFoundGokollab": {
      "notEnrolledInA": "Não Inscrito em um",
      "course": "Curso",
      "yet": "Ainda"
    },
    "noCoursesFoundGokollabDescription": "Explore Cursos de grande impacto criados para ajudar o utilizador a aprender, melhorar e obter sucesso."
  },
  "notFound": {
    "ohNo": "oh não...",
    "weHaveHadAnError": "Ocorreu-nos um erro",
    "error404": "Erro 404",
    "sorryPleaseCheckBack": "Desculpe... volte daqui a um momento."
  },
  "time": {
    "justNow": "agora",
    "timeAgo": "há {value} {unit}",
    "timeAgoFull": "há {value} {unit}",
    "units": {
      "year": "a",
      "years": "anos",
      "month": "m",
      "months": "meses",
      "week": "sem",
      "weeks": "semanas",
      "day": "d",
      "days": "dias",
      "hour": "h",
      "hours": "horas",
      "minute": "m",
      "minutes": "minutos",
      "second": "s",
      "seconds": "Segundos",
      "monthly": "Mensal",
      "weekly": "Semanal",
      "annually": "Anual"
    },
    "dayAbbreviations": {
      "mon": "Seg",
      "tue": "Ter",
      "wed": "Qua",
      "thu": "Qui",
      "fri": "Sex",
      "sat": "Sáb",
      "sun": "Dom"
    }
  },
  "emojiPicker": {
    "notfound": "Nenhum Emoji encontrado",
    "recent": "Utilizado com frequência",
    "smileys": "Emoções e Emotic",
    "people": "Pessoas e Corpo",
    "nature": "Animais e natureza",
    "foods": "Alimentar-se e beber",
    "activity": "Atividade",
    "places": "Viagens e Assentos",
    "objects": "Objetos",
    "symbols": "Símbolos",
    "flags": "Bandeiras",
    "custom": "Personalizado"
  },
  "topNavBarHeaderText": {
    "discussion": "Discussão",
    "learning": "aprendizagem",
    "people": "Pessoas"
  },
  "globalUserProfile": {
    "ownedBy": "Propriedade de {name}",
    "memberships": "Associações",
    "membershipsInCommon": "Associações ({count} em comum)",
    "membersCount": "{count} membros",
    "contributions": "{count} contribuições para {group}",
    "contributionsFor": "Contribuições para",
    "justPosts": "Apenas publicações",
    "postAndComments": "Publicar e comentar",
    "followSuccess": "O utilizador começou a Seguinte",
    "unfollowSuccess": "O utilizador já não está a seguir"
  },
  "profile": {
    "active": "Ativo",
    "ago": "atrás",
    "bio": "Biografia"
  },
  "golive": {
    "golive": "Entrar em direto",
    "selectVideoSourceToStart": "Selecionar uma fonte de vídeo para começar a transmissão",
    "chooseHowToGoLive": "Selecione como pretende entrar em direto",
    "flipCamera": "Inverter câmara",
    "participants": "Participantes",
    "chats": "Chats",
    "react": "React",
    "raise": "Levantar a mão",
    "shareScreen": "Partilhar",
    "letsCheckYourCamAndMic": "Vamos verificar a sua câmara e o microfone",
    "hostedBy": "Hospedado por",
    "join": "Registar-se",
    "needCameraPermission": "Precisa de autorização para câmara",
    "needMicrophonePermission": "Precisa de autorização para microfone",
    "needSpeakerPermission": "Precisa de autorização para altifalante",
    "createLiveVideo": "Gerar um vídeo em direto",
    "host": "Anfitrião",
    "chooseWhereToPost": "Escolher onde publicar",
    "whenAreYouGoingLive": "Quando entra em direto?",
    "postingIn": "publicação em",
    "live": "Ativas",
    "postDetails": "Detalhes da publicação",
    "streamingSoftware": "Software de streaming",
    "streamingSoftwareDescription": "Pode utilizar um software de streaming como o Zoom, OBS ou StreamYard para transmitir diretamente. Basta copiar o URL de transmissão e a chave de transmissão fornecidos para as definições do seu software de streaming. Uma vez configurada, inicie a sua transmissão no software e esta será transmitida em direto para a plataforma selecionada automaticamente.",
    "streamKey": "Chave de transmissão",
    "streamKeyDescription": "Isto pode ser reutilizado sempre que entrar em direto. Só pode transmitir um vídeo em direto de cada vez com a sua chave de transmissão persistente.",
    "serverUrl": "URL do servidor",
    "serverUrlDescription": "Pode ser referido como \"URL\" ou \"Endereço\" no seu software de streaming.",
    "selectVideoSource": "Selecionar Fonte de Vídeo",
    "copyPasteStreamKey": "Copie e cole a chave de transmissão no seu software de streaming.",
    "copyPasteServerUrl": "Copie e cole o URL do servidor no seu software de streaming.",
    "addPostDetails": "Adicionar detalhes da publicação",
    "enterTitle": "Introduza um título",
    "notifyMembers": "Notifique os membros de que está a entrar em direto (envia apenas notificações na aplicação e push)",
    "notifyMembersMobile": "Notifique os membros de que está a entrar em direto",
    "meetingRoom": "Sala de reuniões",
    "meetingRoomDescription": "Utilize a caraterística Salas de reunião para acolher sessões em direto em que todos os participantes podem ligar as suas câmaras Web, tirar o som e interagir em tempo real. Isto cria uma experiência de sala virtual semelhante ao Zoom ou ao Google Meet, permitindo que todos se vejam e falem uns com os outros cara a cara.",
    "cameraControls": "Controlos da câmara",
    "cameraControlsTooltip": "Configure as configuração da sua câmara e de áudio antes de entrar em direto. Certifique-se de que a câmara e o microfone estão devidamente ligados e têm as permissões necessárias.",
    "selectMediaSource": "Selecione uma fonte de multimédia",
    "startScreenShare": "Iniciar partilha de ecrã",
    "stopScreenShare": "Parar partilha de ecrã",
    "wasLive": "esteve em direto",
    "isLive": "está em direto",
    "goingLive": "está a entrar em direto",
    "tapToAddDescription": "Toque para adicionar uma descrição...",
    "selectChannel": "Selecionar canal",
    "saveAsPost": "Manter a transmissão em direto como publicação",
    "selectVideoSourceTooltip": "Pode selecionar entre software de streaming ou webcam quando entrar em direto:\n\n1. Software de streaming\n   • Fornecemos uma chave de transmissão e URL de transmissão.\n   • Precisa de configurar isto no Zoom, OBS ou qualquer software de terceiros que suporte transmissão em direto.\n\n2. Webcam\n   • Entre em direto através da sua câmara e microfone.\n   • Os participantes podem ver a transmissão em direto e interagir através do chat em direto.\n   • Como anfitrião, pode controlar e revogar o acesso à câmara ou ao microfone em qualquer altura.",
    "pleaseSelectCameraMicrophoneSpeaker": "Selecione a câmara, o microfone e o altifalante",
    "pleaseStartStreamBeforeGoingLive": "Inicie a transmissão antes de entrar em direto",
    "watching": "A assistir",
    "processingRecording": "A processar gravação",
    "recordingFailed": "Gravação indisponível",
    "recordingFailedDescription": "Encontrámos um problema ao processar esta sessão em direto e não foi possível guardar a gravação.",
    "streamEndedRecordingWillBeAvailableSoon": "A transmissão terminou. A gravação está a ser processada e estará disponível em breve.",
    "joinStream": "Juntar-se à transmissão",
    "recordingInProgress": "Gravação em curso",
    "recordingNotAvailable": "Gravação falhada",
    "leaveSession": "Sair da Sessão",
    "endSession": "Terminar sessão",
    "rec": "REC",
    "selectCamera": "Selecionar câmara",
    "noCamerasFound": "Nenhuma câmara encontrada",
    "cameraPermissionNeeded": "Autorização da câmara necessária",
    "leave": "Sair",
    "chooseMicCam": "Selecionar microfone/câmara",
    "selectMicrophone": "Selecionar microfone",
    "selectSpeaker": "Selecionar altifalante",
    "noMicrophonesFound": "Não foram encontrados microfones",
    "noSpeakersFound": "Nenhum altifalante encontrado",
    "microphonePermissionNeeded": "Permissão de microfone necessária",
    "speakerPermissionNeeded": "Permissão de altifalante necessária",
    "noParticipantOpenCamOrMic": "Esta reunião não foi gravada porque nenhum participante ativou o microfone ou a câmara. As gravações são criadas apenas quando pelo menos um participante interage."
  }
}
